export default __webpack_public_path__ + "static/media/2_bottom.c56533c4.jpg";